import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { v4 } from 'uuid';
var FileManagerService = /** @class */ (function () {
    function FileManagerService() {
        this.map = new Map();
    }
    FileManagerService.prototype.reset = function () {
        this.map.clear();
    };
    FileManagerService.prototype.add = function (fileElement) {
        fileElement.id = v4();
        this.map.set(fileElement.id, this.clone(fileElement));
        return fileElement;
    };
    FileManagerService.prototype.delete = function (id) {
        this.map.delete(id);
    };
    FileManagerService.prototype.update = function (id, update) {
        var element = this.map.get(id);
        element = Object.assign(element, update);
        this.map.set(element.id, element);
    };
    FileManagerService.prototype.queryInFolder = function (folderId) {
        var _this = this;
        var result = [];
        this.map.forEach(function (element) {
            if (element.parent === folderId) {
                result.push(_this.clone(element));
            }
        });
        if (!this.querySubject) {
            this.querySubject = new BehaviorSubject(result);
        }
        else {
            this.querySubject.next(result);
        }
        return this.querySubject.asObservable();
    };
    FileManagerService.prototype.get = function (id) {
        return this.map.get(id);
    };
    FileManagerService.prototype.getMap = function () {
        return this.map;
    };
    FileManagerService.prototype.getByName = function (name) {
        var foundElement;
        this.map.forEach(function (value, key, self) {
            if (value.name === name) {
                foundElement = self.get(key);
                return;
            }
        });
        return foundElement;
    };
    FileManagerService.prototype.clone = function (element) {
        return JSON.parse(JSON.stringify(element));
    };
    FileManagerService.prototype.sort = function (key, sortVers) {
        var vers = sortVers;
        if (!vers) {
            vers = "asc";
        }
        var newMap = new Map(tslib_1.__spread(this.map.entries()).sort(function (a, b) {
            if (Array.isArray(a) &&
                Array.isArray(b) &&
                a.length === 2 &&
                b.length === 2) {
                var aIsFolder = a[1].isFolder;
                var aFolderName = a[1].name;
                var bIsFolder = b[1].isFolder;
                var bFolderName = b[1].name;
                // if (aIsFolder && bIsFolder) {
                //   if (aFolderName < bFolderName) {
                //     return -1;
                //   }
                //   if (aFolderName > bFolderName) {
                //     return 1;
                //   }
                //   return 0;
                // }
                return aIsFolder === bIsFolder ? ((aFolderName > bFolderName) ? 1 : -1) : aIsFolder ? -1 : 1;
            }
            return 0;
        }));
        this.map = newMap;
    };
    return FileManagerService;
}());
export { FileManagerService };
